import { institutionBiStringsEn, institutionBiStringsFr } from './i18n-institution-bi';
import { institutionRhCompetenciesStrings } from './i18n-institution-rh-competencies';
import {
  institutionRegisterStringsEn,
  institutionRegisterStringsFr,
} from './i18n-institution-register';

/** Merged into i18n.ts — fr/en ici ; les autres langues sont dans `i18n-bundles/institution-<lng>.ts` (chargées à la demande). */
export const institutionOverlay: Record<string, Record<string, string>> = {
  fr: {
    ...institutionBiStringsFr,
    ...institutionRegisterStringsFr,
    ...institutionRhCompetenciesStrings.fr,
  "institution.flows.transferOwner": "Affecter à un autre formateur",
  "institution.flows.transferModalTitle": "Réattribuer la formation",
  "institution.flows.transferModalHint": "Le nouveau formateur devient propriétaire (tous les droits). L’ancien perd l’accès propriétaire et collaborateur sur ce parcours.",
  "institution.flows.transferPickUser": "Nouveau formateur",
  "institution.flows.transferSubmit": "Confirmer le transfert",
  "institution.flows.transferLoadingUsers": "Chargement des comptes…",
  "institution.flows.transferNoCandidates": "Aucun autre collaborateur disponible",
  "institution.flows.transferError": "Transfert impossible",
  "institution.flows.transferSuccess": "Formateur mis à jour",
  "institution.tabs.home": "Accueil",
  "institution.tabs.rhDashboard": "Pilotage RH",
  "institution.tabs.infpc": "INFPC (cofinancement)",
  "institution.infpc.title": "Demande de cofinancement INFPC",
  "institution.infpc.subtitle":
    "Téléversez le formulaire Excel officiel (ex. demande-de-cofinancement-2026.xls) et les données JSON : l’outil interroge les parcours LyrraStudio et remplit les onglets Signalétique, Salariés + et les onglets « Tab.* » par catégorie.",
  "institution.infpc.templateLabel": "Modèle Excel (.xls ou .xlsx)",
  "institution.infpc.templateHint": "Fichier vierge téléchargé sur lifelong-learning.lu, sans modifier la structure.",
  "institution.infpc.companyJson": "company-config (JSON)",
  "institution.infpc.employeesJson": "employees (JSON — tableau)",
  "institution.infpc.employeesHint":
    "Optionnel : une ligne par salarié (lyrraEmail = e-mail apprenant). Vous pouvez mettre [] et compléter les informations personnelles sur chaque fiche apprenant, ou coller un tableau JSON ici.",
  "institution.infpc.trainingsJson": "trainings-config (JSON — tableau)",
  "institution.infpc.allowMissing":
    "Ne pas inclure dans le fichier les apprenants inscrits sans entrée correspondante dans employees (même e-mail)",
  "institution.infpc.skipDraft": "Accepter les parcours encore en brouillon",
  "institution.infpc.generate": "Générer le fichier pré-rempli (.xlsx)",
  "institution.infpc.generating": "Génération…",
  "institution.infpc.success": "Téléchargement lancé.",
  "institution.infpc.error": "Échec de la génération",
  "institution.infpc.docLink": "Voir la spec technique (mapping, calculs, validations)",
  "institution.infpc.flowIdHint":
    "Chaque lyrraFlowId doit être un UUID. Le plus simple : choisissez un parcours ci-dessus puis « Appliquer » — ou copiez l’identifiant dans l’URL du concepteur (segment …/flows/VOTRE_UUID).",
  "institution.infpc.pickFlow": "Parcours de l’établissement",
  "institution.infpc.pickFlowPlaceholder": "— Choisir un parcours —",
  "institution.infpc.applyFlowId": "Appliquer au 1er bloc trainings-config",
  "institution.infpc.flowApplied": "UUID du parcours inséré dans le JSON (première entrée).",
  "institution.infpc.flowsLoading": "Chargement des parcours…",
  "institution.infpc.flowsEmpty": "Aucun parcours trouvé pour cet établissement — créez-en un ou vérifiez le compte.",
  "institution.infpc.mustReplacePlaceholder":
    "Remplacez l’UUID d’exemple par un parcours réel (liste ci-dessus + « Appliquer ») ou attendez le chargement des parcours.",
  "institution.infpc.flowPickerHint":
    "Évite l’erreur « parcours introuvable » : l’API n’accepte que les parcours dont le propriétaire appartient à votre établissement (liste Formations).",
  "institution.tabs.flows": "Formations",
  "institution.tabs.editorShares": "Contenus éditeurs",
  "institution.editorShares.view": "Consulter",
  "institution.editorShares.use": "Utiliser",
  "institution.editorShares.detail": "Détail",
  "institution.editorShares.hideDetail": "Masquer le détail",
  "institution.editorShares.assignTitle": "Assigner à des classes",
  "institution.editorShares.assignHint": "Les élèves des classes cochées recevront ce contenu.",
  "institution.editorShares.assignSubmit": "Assigner",
  "institution.editorShares.assignDone": "{{assigned}} nouvelle(s) inscription(s), {{already}} déjà inscrit(s).",
  "institution.editorShares.assignSkipped": "{{count}} élève(s) sans compte n’ont pas été inscrits.",
  "institution.editorShares.usedIn": "Déjà utilisé dans",
  "institution.editorShares.noClassYet": "Pas encore assigné à une classe.",
  "institution.editorShares.draftHint": "Cette formation n’est pas publiée : vous pouvez la consulter, pas encore l’assigner.",
  "institution.editorShares.noClasses": "Aucune classe dans l’établissement.",
  "institution.editorShares.episodes": "Épisodes",
  "institution.editorShares.pathItems": "Étapes du parcours",
  "institution.editorShares.blocks": "{{count}} blocs",
  "institution.editorShares.episodeCount": "{{count}} épisodes",
  "institution.editorShares.stepCount": "{{count}} étapes",
  "institution.tabs.trash": "Corbeille",
  "institution.trash.subtitle": "Formations et podcasts supprimés logiquement — restaurez-les pour les rendre à nouveau visibles.",
  "institution.trash.loading": "Chargement…",
  "institution.trash.empty": "La corbeille est vide.",
  "institution.trash.sectionFlows": "Formations",
  "institution.trash.sectionPodcasts": "Podcasts",
  "institution.trash.restore": "Restaurer",
  "institution.trash.owner": "Formateur",
  "institution.trash.restoredFlow": "Formation restaurée.",
  "institution.trash.restoredPodcast": "Podcast restauré.",
  "institution.trash.restoreError": "Restauration impossible.",
  "institution.trash.loadError": "Impossible de charger la corbeille.",
  "institution.trash.purgeButton": "Vider la corbeille…",
  "institution.trash.purgeModalTitle": "Vider la corbeille définitivement",
  "institution.trash.purgeModalHint": "Les éléments seront supprimés sans possibilité de restauration (formations, podcasts et épisodes orphelins associés).",
  "institution.trash.purgeScopeLabel": "Périmètre",
  "institution.trash.purgeAllLabel": "Tout supprimer",
  "institution.trash.purgeAllDesc": "Retire définitivement tous les éléments actuellement dans la corbeille.",
  "institution.trash.purgeRangeLabel": "Une période",
  "institution.trash.purgeRangeDesc": "Seuls les éléments mis en corbeille entre ces dates (selon la date de suppression) seront retirés définitivement.",
  "institution.trash.purgeDateFrom": "Du",
  "institution.trash.purgeDateTo": "Au",
  "institution.trash.purgeConfirm": "Supprimer définitivement",
  "institution.trash.purgeSuccess": "Corbeille vidée.",
  "institution.trash.purgeRangeMissingDates": "Indiquez une date de début et une date de fin.",
  "institution.trash.purgeRangeOrderError": "La date de début doit être antérieure à la date de fin.",
  "institution.tabs.supports": "Podcasts",
  "institution.tabs.categories": "Catégories",
  "institution.tabs.templates": "Modèles de blocs",
  "institution.tabs.contentPipeline": "Préparation contenu",
  "institution.tabs.webinars": "Webinaires",
  "institution.tabs.webinarsPilotage": "Pilotage webinaires",
  "institution.webinars.pageTitle": "Paramètres webinaires",
  "institution.webinars.settingsIntro":
    "Activez le module et définissez le message d’attente par défaut. La liste des webinaires et les animateurs autorisés se gèrent dans l’onglet « {{tabName}} ».",
  "institution.webinars.enableForInstitution": "Activer les webinaires pour l’établissement",
  "institution.webinars.enabledBadge": "Module activé",
  "institution.webinars.disabledBadge": "Module désactivé",
  "institution.webinars.sectionModule": "Activation",
  "institution.webinars.sectionModuleHint":
    "Permet aux formateurs de l’établissement de créer et animer des sessions en direct.",
  "institution.webinars.sectionWaitingRoom": "Salle d’attente",
  "institution.webinars.waitingHtmlLabel": "HTML de salle d’attente (défaut)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>Votre message d’accueil…</p>",
  "institution.webinars.waitingHtmlHint":
    "HTML simple affiché aux participants avant le début. Les couleurs suivent la charte de cet espace.",
  "institution.webinars.openPilotage": "Ouvrir le pilotage webinaires",
  "institution.webinars.waitingPreviewTitle": "Aperçu — message d’attente",
  "institution.webinars.waitingPreviewHint":
    "Rendu tel que vu par les participants avant le début du webinaire (couleurs de la charte de cet espace).",
  "institution.webinars.loadError": "Impossible de charger les paramètres webinaires.",
  "institution.webinars.saveSuccess": "Paramètres webinaires enregistrés.",
  "institution.webinars.saveError": "Enregistrement impossible.",
  "institution.tabs.scorm": "Import SCORM",
  "institution.tabs.designers": "Collaborateurs",
  "institution.tabs.learners": "Apprenants",
  "institution.tabs.learnerAnalytics": "Analyse apprenants",
  "institution.tabs.biStudio": "Tableaux BI",
  "institution.tabs.groups": "Groupes",
  "institution.tabs.services": "Services",
  "institution.tabs.sirh": "SIRH (API)",
  "institution.tabs.branding": "Personnalisation",
  "institution.tabs.landing": "Page publique",
  "institution.tabs.webhooks": "Webhooks",
  "institution.tabs.xapi": "xAPI (LRS)",
  "institution.tabs.mcp": "MCP",
  "institution.tabs.billing": "Facturation",
  "institution.nav.section.general": "Général",
  "institution.nav.section.content": "Contenu & formations",
  "institution.nav.section.people": "Équipes & apprenants",
  "institution.nav.section.portal": "Portail & image",
  "institution.nav.section.integrations": "Intégrations",
  "institution.nav.section.subscription": "Abonnement",
  "institution.nav.section.rhTools": "Formation & RH",
  "institution.rhNav.campaigns": "Campagnes",
  "institution.rhNav.codir": "Tableau CODIR",
  "institution.rhNav.catalog": "Catalogue",
  "institution.rhNav.competencies": "Compétences",
  "institution.rhNav.compliance": "Conformité",
  "institution.rhNav.requests": "Demandes & workflows",
  "institution.sidebar.subtitle": "Établissement",
  "institution.sidebar.subtitleRh": "Espace RH",
  "institution.sidebar.subtitleAdmin": "Administration",
  "institution.sidebar.subtitleEducation": "Établissement scolaire",
  "institution.designers.colClasses": "Classes",
  "institution.sidebar.logout": "Déconnexion",
  "institution.sidebar.collapse": "Réduire le menu",
  "institution.sidebar.expandAria": "Agrandir la barre latérale",
  "institution.sidebar.collapseAria": "Réduire la barre latérale",
  "institution.sidebar.language": "Langue",
  "institution.sidebar.languageAria": "Changer la langue",
  "institution.header.workspace": "Espace établissement",
  "institution.common.cancel": "Annuler",
  "institution.common.save": "Enregistrer",
  "institution.common.saving": "Enregistrement…",
  "institution.common.delete": "Supprimer",
  "institution.common.edit": "Modifier",
  "institution.common.create": "Créer",
  "institution.common.add": "Ajouter",
  "institution.common.retry": "Réessayer",
  "institution.common.refresh": "Actualiser",
  "institution.common.search": "Rechercher…",
  "institution.common.loading": "Chargement…",
  "institution.common.page": "Page",
  "institution.common.of": "sur",
  "institution.common.name": "Nom",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.member": "Membre",
  "institution.common.members": "Membres",
  "institution.common.back": "Retour",
  "institution.common.view": "Voir",
  "institution.common.duplicate": "Dupliquer",
  "institution.common.toggleStatus": "Activer/Désactiver",
  "institution.common.author": "Auteur",
  "institution.common.title": "Titre",
  "institution.common.status": "Statut",
  "institution.common.type": "Type",
  "institution.common.actions": "Actions",
  "institution.common.createdAt": "Créé le",
  "institution.common.assignedTo": "Assigné à",
  "institution.common.completion": "Complétion",
  "institution.common.learners": "Apprenants",
  "institution.common.empty": "—",
  "institution.status.draft": "Brouillon",
  "institution.status.published": "Publié",
  "institution.status.archived": "Archivé",
  "institution.status.allStatuses": "Tous les statuts",
  "institution.status.allTypes": "Tous les types",
  "institution.dashboard.loading": "Chargement du dashboard…",
  "institution.dashboard.loadError": "Impossible de charger le dashboard.",
  "institution.dashboard.activity.completion": "Terminaison",
  "institution.dashboard.activity.enrollment": "Inscription",
  "institution.dashboard.activity.milestone": "Jalon",
  "institution.dashboard.activity.feedback": "Retour",
  "institution.dashboard.activity.start": "Démarrage",
  "institution.dashboard.activity.1": "Marie Dupont a terminé « UX Fundamentals »",
  "institution.dashboard.activity.2": "12 nouveaux apprenants inscrits à « Design Thinking »",
  "institution.dashboard.activity.3": "Le groupe « Cohorte T3 » a atteint 80 % de complétion",
  "institution.dashboard.activity.4": "L’enquête NPS a reçu 24 nouvelles réponses",
  "institution.dashboard.activity.5": "Jean Martin a démarré « Méthodes agiles »",
  "institution.dashboard.time.5m": "Il y a 5 min",
  "institution.dashboard.time.1h": "Il y a 1 h",
  "institution.dashboard.time.3h": "Il y a 3 h",
  "institution.dashboard.time.5h": "Il y a 5 h",
  "institution.dashboard.time.6h": "Il y a 6 h",
  "institution.dashboard.activity.flowCompleted": "{{name}} a terminé « {{flow}} »",
  "institution.dashboard.activity.participantJoined": "Apprenant enregistré : {{email}}",
  "institution.dashboard.activity.flowStarted": "{{name}} a démarré « {{flow}} »",
  "institution.dashboard.chartTopFlowsEmpty": "Pas encore assez de données. Publiez des formations et invitez des apprenants.",
  "institution.dashboard.activityEmpty": "Aucune activité récente.",
  "institution.dashboard.home.greeting": "Bonjour, {{name}}",
  "institution.dashboard.home.greetingSubtitle": "Vue d’ensemble de votre établissement — formations, apprenants et activité récente.",
  "institution.dashboard.home.defaultName": "équipe",
  "institution.dashboard.home.primaryCta": "Gérer les formations",
  "institution.dashboard.home.secondaryCta": "Voir les apprenants",
  "institution.dashboard.home.completionRate": "Taux de complétion",
  "institution.dashboard.home.quickAccess": "Accès rapides",
  "institution.dashboard.home.viewAllActivity": "Toute l’activité",
  "institution.dashboard.home.calendarKicker": "Activité du mois",
  "institution.dashboard.home.alertNotStarted": "{{count}} inscription(s) non démarrée(s)",
  "institution.dashboard.home.alertStalled": "{{count}} progression(s) en pause",
  "institution.dashboard.home.topFlows": "Formations les plus suivies",
  "institution.dashboard.home.topFlowsHint": "Taux de complétion par parcours sur la période.",
  "institution.dashboard.home.periodLabel": "Période",
  "institution.groups.title": "Groupes",
  "institution.groups.classHint": "Un groupe rassemble des apprenants pour une campagne ou un filtre. Une classe, avec son responsable formation et ses formateurs, se gère dans l’onglet Classes.",
  "institution.tabs.classes": "Classes",
  "institution.tabs.evaluations": "Évaluations",
  "institution.evaluations.title": "Évaluations",
  "institution.evaluations.subtitle": "Résultats d’une classe sur une formation. Les sondages et l’auto-évaluation ne comptent pas.",
  "institution.evaluations.loadError": "Impossible de charger les évaluations.",
  "institution.evaluations.chooseClass": "Choisir une classe",
  "institution.evaluations.chooseFlow": "Choisir une formation",
  "institution.evaluations.emptyClass": "Choisissez une classe pour voir ses résultats.",
  "institution.evaluations.emptyFlow": "Aucune formation jouée par cette classe.",
  "institution.evaluations.emptyLearners": "Cette classe n’a pas encore d’apprenants.",
  "institution.evaluations.viewGrid": "Tableau",
  "institution.evaluations.viewQueue": "File de correction",
  "institution.evaluations.viewStats": "Questions",
  "institution.evaluations.viewSettings": "Règles",
  "institution.evaluations.viewCompetency": "Référentiel",
  "institution.evaluations.learner": "Apprenant",
  "institution.evaluations.total": "Total",
  "institution.evaluations.threshold": "Seuil",
  "institution.evaluations.queueEmpty": "Rien à corriger.",
  "institution.evaluations.proposal": "Proposition",
  "institution.evaluations.comment": "Commentaire pour l’apprenant",
  "institution.evaluations.validate": "Valider",
  "institution.evaluations.passPercent": "Seuil de réussite (%)",
  "institution.evaluations.attemptRule": "Essai retenu",
  "institution.evaluations.ruleLast": "Dernier essai",
  "institution.evaluations.ruleBest": "Meilleur essai",
  "institution.evaluations.noSuggestion": "Aucune montée de niveau à proposer.",
  "institution.evaluations.applyLevel": "Proposer la montée",
  "institution.evaluations.learnerTitle": "Mes résultats",
  "institution.evaluations.attemptsLeft": "Essais restants",
  "institution.evaluations.attemptsReached": "Nombre d’essais atteint.",
  "institution.evaluations.openFromClass": "Voir les évaluations",
  "institution.evaluations.status.passed": "Réussi",
  "institution.evaluations.status.failed": "Non réussi",
  "institution.evaluations.status.toReview": "En correction",
  "institution.evaluations.status.inProgress": "En cours",
  "institution.evaluations.status.notStarted": "Non commencé",
  "institution.evaluations.status.counted": "Compté",
  "institution.evaluations.signal.easy": "Trop facile",
  "institution.evaluations.signal.hard": "Trop difficile",
  "institution.evaluations.signal.balanced": "Équilibrée",
  "institution.evaluations.signal.insufficient": "Pas assez de réponses",
  "institution.classes.title": "Classes",
  "offline.banner.offline": "Hors ligne : vos formations téléchargées restent disponibles.",
  "offline.banner.offlinePending": "Hors ligne : {{count}} enregistrement(s) de progression seront envoyés au retour de la connexion.",
  "offline.banner.syncing": "Synchronisation de votre progression… ({{count}} en attente)",
  "offline.banner.synced": "Progression synchronisée ({{count}}).",
  "offline.banner.failed": "{{count}} enregistrement(s) de progression refusé(s) par le serveur. Prévenez votre enseignant si votre avancement semble incomplet.",
  "offline.flow.download": "Rendre disponible hors ligne",
  "offline.flow.progressContent": "Téléchargement du contenu…",
  "offline.flow.progressMedia": "Médias {{done}} / {{total}}…",
  "offline.flow.progressApp": "Préparation de l’application hors ligne…",
  "offline.flow.ready": "Disponible hors ligne",
  "offline.flow.partial": "{{count}} média(s) externe(s) ou indisponible(s) : lecture en ligne uniquement.",
  "offline.flow.update": "Mettre à jour",
  "offline.flow.remove": "Retirer",
  "offline.flow.notAvailable": "Non téléchargée : connexion nécessaire",
  "offline.flow.unsupported": "Ce navigateur ne permet pas le mode hors ligne.",
  "offline.flow.error": "Téléchargement interrompu. Réessayez avec une connexion.",
  "institution.classes.importCsv": "Importer (CSV)",
  "institution.classes.importTitle": "Importer des élèves dans la classe",
  "institution.classes.importHelp": "Fichier CSV avec trois colonnes : prénom, nom, e-mail (séparateur « ; » ou « , »). {{max}} lignes maximum. Les comptes manquants sont créés comme comptes élèves.",
  "institution.classes.importTemplate": "Télécharger le modèle",
  "institution.classes.importFile": "Fichier CSV",
  "institution.classes.importPreview": "{{count}} élève(s) lu(s) dans {{file}}.",
  "institution.classes.importSkipped": "Lignes ignorées faute d’e-mail : {{lines}}",
  "institution.classes.importInvite": "Envoyer à chaque nouveau compte un e-mail pour choisir son mot de passe",
  "institution.classes.importRun": "Importer",
  "institution.classes.importResult": "{{added}} élève(s) ajouté(s) à la classe, {{created}} compte(s) créé(s), {{already}} déjà dans la classe, {{invited}} invitation(s) en cours d’envoi.",
  "institution.classes.importErrors": "{{count}} ligne(s) non importée(s) :",
  "institution.classes.importErrorLine": "Ligne {{line}} ({{email}}) : {{reason}}",
  "institution.classes.importEmpty": "Aucun élève trouvé dans ce fichier.",
  "institution.classes.importTooMany": "Le fichier dépasse {{max}} lignes : découpez-le.",
  "institution.classes.importReadError": "Lecture du fichier impossible.",
  "institution.classes.close": "Fermer",
  "institution.classes.notifyStudents": "Prévenir les élèves nouvellement inscrits par e-mail",
  "institution.classes.flowsTitle": "Formations de la classe",
  "institution.classes.flowsHint": "Assignez une formation publiée à toute la classe. Les élèves déjà inscrits ne sont pas dupliqués.",
  "institution.classes.chooseFlow": "Choisir une formation publiée",
  "institution.classes.assignFlow": "Assigner à la classe",
  "institution.classes.assignDone": "{{assigned}} élève(s) inscrit(s), {{already}} déjà inscrit(s).",
  "institution.classes.noFlows": "Aucune formation publiée disponible pour cet établissement.",
  "institution.classes.enrolledCount": "{{enrolled}} / {{total}} inscrits",
  "institution.classes.subtitle": "Une classe a un responsable, des formateurs et des élèves. Importez la liste des élèves et assignez-leur des formations en une fois.",
  "institution.classes.create": "Créer une classe",
  "institution.classes.loadError": "Impossible de charger les classes.",
  "institution.classes.saveError": "Enregistrement impossible.",
  "institution.classes.search": "Rechercher une classe…",
  "institution.classes.empty": "Aucune classe. Créez la première depuis cet écran.",
  "institution.classes.emptyFilter": "Aucune classe ne correspond à la recherche.",
  "institution.classes.colName": "Classe",
  "institution.classes.lead": "Responsable de classe",
  "institution.classes.leadPlaceholder": "Choisir un responsable de classe",
  "institution.classes.leadHint": "Le responsable suit la classe (professeur principal, coordinateur ou direction). Les formateurs y enseignent leurs matières.",
  "institution.classes.leadMissing": "Aucun responsable",
  "institution.classes.noLead": "Créez d’abord un compte formateur, responsable formation ou administrateur dans Collaborateurs.",
  "institution.classes.trainers": "Formateurs",
  "institution.classes.learners": "Apprenants",
  "institution.classes.addTrainer": "Ajouter un formateur",
  "institution.classes.addLearner": "Ajouter un apprenant",
  "institution.classes.noTrainers": "Aucun formateur dans cette classe.",
  "institution.classes.noLearners": "Aucun apprenant dans cette classe.",
  "institution.classes.noTrainerAvailable": "Aucun formateur disponible.",
  "institution.classes.noLearnerAvailable": "Aucun apprenant disponible.",
  "institution.classes.searchPeople": "Rechercher…",
  "institution.classes.back": "Retour aux classes",
  "institution.classes.remove": "Retirer",
  "institution.classes.modalCreate": "Créer une classe",
  "institution.classes.modalEdit": "Modifier la classe",
  "institution.classes.fieldName": "Nom de la classe",
  "institution.classes.confirmDeleteTitle": "Supprimer cette classe ?",
  "institution.classes.confirmDeleteBody": "La classe « {{name}} » sera supprimée. Les comptes ne sont pas supprimés.",
  "institution.classes.confirmRemoveTitle": "Retirer cette personne ?",
  "institution.classes.confirmRemoveBody": "{{name}} sera retiré de la classe. Le compte n’est pas supprimé.",
  "institution.groups.countShown": "{{count}} groupe(s)",
  "institution.groups.subtitle": "{{count}} groupe(s) dans votre établissement",
  "institution.groups.create": "Créer un groupe",
  "institution.groups.statGroups": "Groupes",
  "institution.groups.statTotalMembers": "Membres total",
  "institution.groups.statEmpty": "Groupes vides",
  "institution.groups.loadError": "Impossible de charger les groupes.",
  "institution.groups.searchPh": "Rechercher un groupe…",
  "institution.groups.colGroup": "Groupe",
  "institution.groups.colCreated": "Créé le",
  "institution.groups.memberCount": "{{count}} membre(s)",
  "institution.groups.emptyNone": "Aucun groupe. Créez votre premier groupe.",
  "institution.groups.emptyFilter": "Aucun groupe ne correspond à la recherche.",
  "institution.groups.backList": "Retour aux groupes",
  "institution.groups.addLearner": "Ajouter un apprenant",
  "institution.groups.dateCreated": "Date de création",
  "institution.groups.colMember": "Membre",
  "institution.groups.colAdded": "Ajouté le",
  "institution.groups.noMembers": "Aucun membre dans ce groupe",
  "institution.groups.loadGroupError": "Impossible de charger le groupe",
  "institution.groups.panelTitle": "Ajouter des apprenants",
  "institution.groups.noLearnersAvailable": "Aucun apprenant disponible",
  "institution.groups.noResults": "Aucun résultat",
  "institution.groups.modalEdit": "Modifier le groupe",
  "institution.groups.modalCreate": "Créer un groupe",
  "institution.groups.groupName": "Nom du groupe",
  "institution.groups.removeFromGroup": "Retirer du groupe",
  "institution.groups.confirmDeleteTitle": "Supprimer ce groupe ?",
  "institution.groups.confirmDeleteBody": "Le groupe « {{name}} » sera supprimé. Les apprenants restent dans l’établissement, sans ce rattachement.",
  "institution.groups.confirmRemoveTitle": "Retirer ce membre ?",
  "institution.groups.confirmRemoveBody": "{{name}} sera retiré du groupe « {{group}} ». Son compte n’est pas supprimé.",
  "institution.groups.confirmRemoveAction": "Retirer du groupe",
  "institution.groups.noTeacher": "Aucun professeur",
  "institution.groups.teacherLabel": "Professeur responsable",
  "institution.groups.teacherHint": "Il retrouve ce groupe dans son espace et peut y ajouter ou retirer des élèves.",
  "institution.groups.teacherIs": "Professeur : {{name}}",
  "institution.groups.teacherTitle": "Mes groupes de soutien",
  "institution.groups.teacherHint2": "Les groupes qui vous sont attribués et ceux que vous avez créés. Vous pouvez y ajouter des élèves de vos classes ou en retirer, et supprimer les groupes que vous avez créés.",
  "institution.groups.colTeacher": "Professeur",
  "institution.groups.saveError": "Enregistrement impossible.",
  "institution.groups.teacherLearnersHint": "Seuls les élèves de vos classes sont proposés.",
  "institution.services.title": "Services entreprise",
  "institution.services.subtitle":
    "Référentiel des services (RH, Finance, etc.). Les apprenants y sont affectés depuis la fiche apprenant.",
  "institution.services.create": "Nouveau service",
  "institution.services.loadError": "Impossible de charger les services.",
  "institution.services.empty": "Aucun service. Créez-en pour les proposer à l’affectation des apprenants.",
  "institution.services.modalCreate": "Créer un service",
  "institution.services.modalEdit": "Modifier le service",
  "institution.services.fieldName": "Nom du service",
  "institution.services.deleteConfirm": "Supprimer ce service ? Les comptes apprenants rattachés n’auront plus de service (l’affectation sera retirée).",
  "institution.services.listSubtitle": "{{count}} service(s) dans votre établissement",
  "institution.services.intro":
    "Référentiel des services (RH, Finance, etc.). Les apprenants y sont affectés depuis la fiche apprenant.",
  "institution.services.statTotal": "Services",
  "institution.services.statWithDesc": "Avec description",
  "institution.services.statNoDesc": "Sans description",
  "institution.services.searchPh": "Rechercher un service…",
  "institution.services.colService": "Service",
  "institution.services.colCreated": "Créé le",
  "institution.services.emptyNone": "Aucun service. Créez votre premier service.",
  "institution.services.emptyFilter": "Aucun service ne correspond à la recherche.",
  "institution.services.countShown": "{{count}} service(s)",
  "institution.flows.title": "Formations",
  "institution.flows.subtitle": "Gérez vos formations",
  "institution.flows.statTotal": "Total formations",
  "institution.flows.statPublished": "Publiés",
  "institution.flows.statLearners": "Total apprenants",
  "institution.flows.searchPh": "Rechercher une formation…",
  "institution.flows.colName": "Nom",
  "institution.flows.empty": "Aucune formation trouvée",
  "institution.flows.badgeEnterprise": "Besoin entreprise",
  "institution.flows.deleteEnterpriseTooltip": "Mettre en corbeille (besoin entreprise)",
  "institution.flows.deleteEnterpriseTitle": "Retirer la formation « besoin entreprise » ?",
  "institution.flows.deleteEnterpriseHint": "Le parcours sera mis en corbeille (suppression logique). Les formateurs ne peuvent pas effectuer cette action ; seuls l’administrateur d’établissement, le DRH ou la RH peuvent la restaurer ou la retirer depuis ce tableau.",
  "institution.flows.deleteEnterpriseConfirm": "Mettre en corbeille",
  "institution.flows.deleteEnterpriseSuccess": "Formation mise en corbeille.",
  "institution.flows.deleteEnterpriseError": "Action impossible.",
  "institution.learningPaths.sectionTitle": "Parcours de formation (learning paths)",
  "institution.learningPaths.sectionSubtitle": "Parcours dont le créateur appartient à votre établissement.",
  "institution.learningPaths.searchPh": "Rechercher un parcours…",
  "institution.learningPaths.colItems": "Contenus",
  "institution.learningPaths.colAssignments": "Assignations",
  "institution.learningPaths.transferOwner": "Réattribuer le propriétaire",
  "institution.learningPaths.transferModalTitle": "Changer le propriétaire du parcours",
  "institution.learningPaths.transferModalHint":
    "Le nouveau compte devient propriétaire ; les médias de médiathèque référencés (ex. couverture) suivent lorsque c’est traçable en base.",
  "institution.learningPaths.transferPickUser": "Nouveau propriétaire",
  "institution.learningPaths.transferSubmit": "Confirmer le transfert",
  "institution.learningPaths.transferLoadingUsers": "Chargement des comptes…",
  "institution.learningPaths.transferNoCandidates": "Aucun autre collaborateur disponible",
  "institution.learningPaths.transferError": "Transfert impossible",
  "institution.learningPaths.transferSuccess": "Propriétaire mis à jour",
  "institution.learningPaths.empty": "Aucun parcours trouvé",
  "institution.supports.title": "Podcasts",
  "institution.supports.subtitle": "Podcasts et contenus audio",
  "institution.supports.searchPh": "Rechercher un podcast…",
  "institution.supports.empty": "Aucun podcast trouvé",
  "institution.supports.typeDictation": "Dictée",
  "institution.supports.typeText": "Texte",
  "institution.supports.typeAi": "IA",
  "institution.supports.typePodcast": "Podcast",
  "institution.supports.allProductionStatuses": "Tous les statuts",
  "institution.supports.colKind": "Type",
  "institution.supports.colEpisodes": "Épisodes",
  "institution.supports.colProducer": "Producteur",
  "institution.supports.colCreator": "Créé par",
  "institution.supports.loadError": "Impossible de charger les podcasts.",
  "institution.supports.transferOwner": "Réattribuer le créateur du podcast",
  "institution.supports.transferModalTitle": "Changer le propriétaire du podcast",
  "institution.supports.transferModalHint":
    "Le nouveau compte devient créateur du podcast ; les épisodes et médias de médiathèque référencés suivent lorsque c’est traçable en base.",
  "institution.supports.transferPickUser": "Nouveau créateur",
  "institution.supports.transferSubmit": "Confirmer le transfert",
  "institution.supports.transferLoadingUsers": "Chargement des comptes…",
  "institution.supports.transferNoCandidates": "Aucun autre collaborateur disponible",
  "institution.supports.transferError": "Transfert impossible",
  "institution.supports.transferSuccess": "Créateur mis à jour",
  "institution.supports.previewError": "Impossible d’ouvrir l’aperçu du podcast.",
  "institution.podcastProduction.shell": "Coquille",
  "institution.podcastProduction.assigned": "Assigné",
  "institution.podcastProduction.in_production": "En production",
  "institution.podcastProduction.ready": "Prêt",
  "institution.categories.title": "Catégories",
  "institution.categories.subtitle": "Organisez vos formations par thématique",
  "institution.categories.add": "Ajouter",
  "institution.categories.edit": "Modifier la catégorie",
  "institution.categories.new": "Nouvelle catégorie",
  "institution.categories.usage": "{{count}} formation(s)",
  "institution.categories.pageSubtitle": "Organisez vos contenus par catégorie",
  "institution.categories.namePlaceholder": "Nom de la catégorie",
  "institution.categories.color": "Couleur",
  "institution.categories.descShortPh": "Description courte",
  "institution.categories.usageTimes": "({{count}} utilisations)",
  "institution.templates.title": "Modèles de blocs",
  "institution.templates.subtitle": "Bibliothèque de modèles réutilisables",
  "institution.templates.statTotal": "Modèles",
  "institution.templates.statUsage": "Utilisations totales",
  "institution.templates.mostUsed": "Type le plus utilisé",
  "institution.templates.preview": "Aperçu",
  "institution.templates.searchPh": "Rechercher un modèle…",
  "institution.templates.copySuffix": " (copie)",
  "institution.templates.empty": "Aucun modèle trouvé",
  "institution.templates.loadFormatError": "Impossible de lire les modèles (réponse serveur invalide).",
  "institution.templates.usesShort": "{{count}} utilisations",
  "institution.templates.filterAll": "Tous les types",
  "institution.blockTypes.text": "Texte",
  "institution.blockTypes.quiz": "Quiz",
  "institution.blockTypes.video": "Vidéo",
  "institution.blockTypes.audio": "Audio",
  "institution.blockTypes.image": "Image",
  "institution.blockTypes.document": "Document",
  "institution.blockTypes.code": "Code",
  "institution.blockTypes.discussion": "Discussion",
  "institution.scorm.title": "Import SCORM",
  "institution.scorm.subtitle": "Importez des paquets SCORM 1.2 ou 2004",
  "institution.scorm.dropHere": "Glissez-déposez votre fichier SCORM (.zip) ici",
  "institution.scorm.browseHint": "ou cliquez pour parcourir",
  "institution.scorm.selectedFile": "Fichier sélectionné : {{name}}",
  "institution.scorm.startImport": "Lancer l'import",
  "institution.scorm.importingNamed": "Import en cours : {{name}}",
  "institution.scorm.analyzing": "Analyse des modules… {{pct}}%",
  "institution.scorm.historyTitle": "Historique des imports",
  "institution.scorm.colFile": "Fichier",
  "institution.scorm.colDate": "Date",
  "institution.scorm.colStatus": "Statut",
  "institution.scorm.colModules": "Modules",
  "institution.scorm.colVersion": "Version",
  "institution.scorm.colFlow": "Formation",
  "institution.scorm.empty": "Aucun import pour le moment. Déposez un fichier .zip SCORM ci-dessus.",
  "institution.scorm.openFlow": "Ouvrir",
  "institution.scorm.statusImporting": "Import en cours…",
  "institution.scorm.statusSuccess": "Succès",
  "institution.scorm.statusError": "Erreur",
  "institution.designers.title": "Collaborateurs",
  "institution.designers.subtitle": "Comptes de l’établissement, regroupés par métier : formateurs, responsables formation, RH/DRH et managers.",
  "institution.designers.invite": "Inviter",
  "institution.designers.statTotal": "Total collaborateurs",
  "institution.designers.statActiveMonth": "Actifs ce mois",
  "institution.designers.statFlows": "Formations créées (cumul)",
  "institution.designers.inviteTitle": "Inviter un collaborateur",
  "institution.designers.inviteHelp": "Choisissez le rôle : Formateur (contenus / formations), DRH, RH, ou Admin (administrateur de l’établissement sur Lyrra).",
  "institution.designers.emailPh": "adresse@email.com",
  "institution.designers.sendInvite": "Envoyer l'invitation",
  "institution.designers.loadError": "Impossible de charger les collaborateurs",
  "institution.designers.inviteFail": "Échec de l'invitation",
  "institution.designers.actionFail": "Action impossible",
  "institution.designers.searchPh": "Rechercher par nom ou email…",
  "institution.designers.colName": "Nom",
  "institution.designers.colEmail": "Email",
  "institution.designers.colRole": "Rôle",
  "institution.designers.colProjects": "Projets",
  "institution.designers.colLastActivity": "Dernière activité",
  "institution.designers.colStatus": "Statut",
  "institution.designers.colActions": "Actions",
  "institution.designers.empty": "Aucun collaborateur trouvé",
  "institution.designers.roleAdmin": "Admin",
  "institution.designers.roleTeacher": "Formateur",
  "institution.designers.roleTrainingLead": "Resp. formation",
  "institution.designers.roleCollaborator": "Collaborateur",
  "institution.designers.roleOptFormateur": "Formateur",
  "institution.designers.roleOptDrh": "DRH",
  "institution.designers.roleOptRh": "RH",
  "institution.designers.roleOptAdmin": "Admin",
  "institution.designers.statusActive": "Actif",
  "institution.designers.statusInvited": "Invité",
  "institution.designers.statusSuspended": "Suspendu",
  "institution.designers.menuView": "Voir le profil",
  "institution.designers.menuMakeAdmin": "Rendre admin",
  "institution.designers.menuSuspend": "Suspendre",
  "institution.designers.menuRemove": "Retirer",
  "institution.designers.noLinkedLearner": "Aucun profil apprenant lié trouvé pour cet email.",
  "institution.designers.createLinkedLearner": "Créer la fiche apprenant",
  "institution.designers.creatingLinkedLearner": "Création…",
  "institution.designers.createLinkedLearnerFail": "Impossible de créer la fiche apprenant",
  "institution.mcp.title": "MCP — Model Context Protocol",
  "institution.landing.designerTitle": "Designer de page",
  "institution.learners.title": "Apprenants",
  "institution.learners.searchPh": "Rechercher un apprenant…",
  "institution.learners.filterStatus": "Statut",
  "institution.learners.filterPlaceholder": "Filtrer",
  "institution.learners.selectedCount": "{{count}} sélectionné(s)",
  "institution.learners.exportSelection": "Exporter la sélection",
  "institution.learners.exportAll": "Exporter tout",
  "institution.learners.colLearner": "Apprenant",
  "institution.learners.colGroup": "Groupe",
  "institution.learners.colLastActive": "Dernière activité",
  "institution.learners.colStatus": "Statut",
  "institution.learners.empty": "Aucun apprenant trouvé",
  "institution.learners.countList": "{{count}} apprenant(s)",
  "institution.learners.subtitle": "{{count}} apprenant(s) inscrits dans votre établissement",
  "institution.learners.importCsv": "Import CSV",
  "institution.learners.add": "Ajouter",
  "institution.learners.addModalTitle": "Nouvel apprenant",
  "institution.learners.addModalHint":
    "Crée la fiche dans votre établissement. Si l’e-mail n’a pas encore de compte LyrraStudio, un message permet de définir le mot de passe.",
  "institution.learners.addEmail": "E-mail",
  "institution.learners.addSendInvitation": "Envoyer l’e-mail d’invitation (nouveau compte uniquement)",
  "institution.learners.addSubmit": "Créer",
  "institution.learners.addError": "Impossible de créer l’apprenant",
  "institution.learners.statLearners": "Apprenants",
  "institution.learners.statActive30": "Actifs (30j)",
  "institution.learners.statEnrollments": "Inscriptions",
  "institution.learners.statCompleted": "Formations terminées",
  "institution.learners.statusAll": "Tous les statuts",
  "institution.learners.statusActive": "Actif",
  "institution.learners.statusInactive": "Inactif",
  "institution.learners.statusCompleted": "Terminé",
  "institution.learners.sheetTitle": "Fiche apprenant",
  "institution.learners.openProfileDetail": "Détail du profil",
  "institution.learners.groupsCatalogTitle": "Groupes paramétrés",
  "institution.learners.groupsCatalogSubtitle": "Liste définie dans l’onglet « Groupes » de votre établissement.",
  "institution.learners.replacePhoto": "Remplacer",
  "institution.learners.addPhoto": "Ajouter une photo",
  "institution.learners.removePhoto": "Supprimer",
  "institution.learners.firstName": "Prénom",
  "institution.learners.lastName": "Nom",
  "institution.learners.save": "Enregistrer",
  "institution.learners.deactivate": "Désactiver",
  "institution.learners.reactivate": "Réactiver",
  "institution.learners.lastActivity": "Dernière activité :",
  "institution.learners.paths": "Parcours ({{count}})",
  "institution.learners.noPaths": "Aucun parcours assigné",
  "institution.learners.noFlowsEnrolled": "Aucune formation inscrite",
  "institution.learners.done": "Terminé",
  "institution.learners.inProgress": "En cours",
  "institution.learners.itemsProgress": "{{done}}/{{total}} contenus",
  "institution.learners.flows": "Formations",
  "institution.learners.completedF": "Terminées",
  "institution.learners.totalTime": "Temps total",
  "institution.learners.progress": "Progression",
  "institution.learners.flowDone": "Terminée",
  "institution.learners.blocks": "{{visited}}/{{total}} blocs",
  "institution.learners.score": "Score : {{score}}%",
  "institution.learners.sessions": "{{count}} sessions",
  "institution.learners.started": "Début :",
  "institution.learners.ended": "Fin :",
  "institution.learners.lastAccess": "Dernier accès :",
  "institution.learners.podcasts": "Podcasts",
  "institution.learners.noPodcastListen": "Aucune écoute enregistrée",
  "institution.learners.deleteTitle": "Supprimer cet apprenant ?",
  "institution.learners.deleteDesc": "Êtes-vous sûr de vouloir supprimer définitivement {{name}} ({{email}}) ? Cette action est irréversible et supprimera toutes ses données associées.",
  "institution.learners.deactivateTitle": "Désactiver cet apprenant ?",
  "institution.learners.reactivateTitle": "Réactiver cet apprenant ?",
  "institution.learners.deactivateDesc": "{{name}} ne pourra plus accéder aux formations tant qu’il sera désactivé.",
  "institution.learners.reactivateDesc": "{{name}} retrouvera l’accès à ses formations.",
  "institution.learners.deleteLearner": "Supprimer cet apprenant",
  "institution.learners.photoUploadError": "Erreur lors de l’upload de la photo",
  "institution.learners.photoRemoveError": "Erreur lors de la suppression",
  "institution.learners.service": "Service",
  "institution.learners.serviceHint": "Choisissez une entrée du référentiel (onglet Services). Tapez pour filtrer la liste.",
  "institution.learners.serviceSearch": "Rechercher un service…",
  "institution.learners.serviceNone": "Aucun service",
  "institution.learners.infpc.sectionTitle": "Informations personnelles",
  "institution.learners.infpc.sectionHint":
    "Compléments utiles pour les démarches administratives et les déclarations liées à la formation (champs facultatifs selon les cas).",
  "institution.learners.infpc.gender": "Genre",
  "institution.learners.infpc.genderPlaceholder": "—",
  "institution.learners.infpc.genderM": "Masculin",
  "institution.learners.infpc.genderF": "Féminin",
  "institution.learners.infpc.csp": "Catégorie socioprofessionnelle",
  "institution.learners.infpc.cspPlaceholder": "— Choisir —",
  "institution.learners.infpc.csp.manual_worker": "Ouvrier",
  "institution.learners.infpc.csp.employee": "Employé",
  "institution.learners.infpc.csp.technician": "Technicien",
  "institution.learners.infpc.csp.supervisor": "Agent de maîtrise",
  "institution.learners.infpc.csp.executive": "Cadre",
  "institution.learners.infpc.csp.director": "Dirigeant",
  "institution.learners.infpc.hasDiploma": "Diplôme (niveau requis)",
  "institution.learners.infpc.seniority": "Ancienneté (années)",
  "institution.learners.infpc.age": "Âge",
  "institution.learners.infpc.salariePlus": "Salarié +",
  "institution.learners.infpc.salariePlusType": "Type Salarié +",
  "institution.learners.infpc.salariePlusTypePlaceholder": "—",
  "institution.learners.infpc.salariePlusType1": "Type 1 (jeune / sans diplôme requis)",
  "institution.learners.infpc.salariePlusType2": "Type 2",
  "institution.learners.infpc.hireDate": "Date d’embauche (JJ/MM/AAAA)",
  "institution.learners.infpc.birthDate": "Date de naissance (JJ/MM/AAAA)",
  "institution.learners.infpc.save": "Enregistrer les informations",
  "institution.learners.infpc.saved": "Informations enregistrées.",
  "institution.learners.exportSheetLearners": "Apprenants",
  "institution.learners.exportSheetDetails": "Détails formations",
  "institution.learners.export.firstName": "Prénom",
  "institution.learners.export.lastName": "Nom",
  "institution.learners.export.groupCol": "Groupe",
  "institution.learners.export.enrollments": "Formations inscrites",
  "institution.learners.export.completed": "Formations terminées",
  "institution.learners.export.progressPct": "Progression (%)",
  "institution.learners.export.totalMin": "Temps total (min)",
  "institution.learners.export.lastAct": "Dernière activité",
  "institution.learners.export.statusCol": "Statut",
  "institution.learners.export.learnerCol": "Apprenant",
  "institution.learners.export.typeCol": "Type",
  "institution.learners.export.titleCol": "Titre",
  "institution.learners.export.blocks": "Blocs visités / Total",
  "institution.learners.export.sessionsDone": "Sessions terminées",
  "institution.learners.export.avgScore": "Score moyen (%)",
  "institution.learners.export.timeMin": "Temps passé (min)",
  "institution.learners.export.dateStart": "Date début",
  "institution.learners.export.dateEnd": "Date fin",
  "institution.learners.export.lastAcc": "Dernier accès",
  "institution.learners.export.typeCourse": "Formation",
  "institution.learners.export.typePath": "Parcours",
  "institution.reminders.openPanel": "Rappels e-mail",
  "institution.reminders.panelTitle": "Rappels",
  "institution.reminders.panelSubtitle":
    "Alertes automatiques envoyées aux apprenants concernés. Vérification planifiée chaque heure (heure UTC choisie). Un même rappel n’est envoyé qu’une fois par apprenant et par règle.",
  "institution.reminders.sectionRules": "Règles",
  "institution.reminders.sectionLogs": "Journal d’envoi",
  "institution.reminders.addRule": "Ajouter une alerte",
  "institution.reminders.removeRule": "Supprimer cette alerte",
  "institution.reminders.save": "Enregistrer les règles",
  "institution.reminders.loadError": "Impossible de charger les rappels.",
  "institution.reminders.saveError": "Enregistrement impossible.",
  "institution.reminders.rulesEmpty": "Aucune alerte. Ajoutez une règle, ou enregistrez une liste vide pour désactiver tous les rappels sur ce contenu.",
  "institution.reminders.logsEmpty": "Aucun envoi enregistré pour l’instant.",
  "institution.reminders.utcHint":
    "Choisissez l’heure UTC à laquelle le serveur évalue cette règle (0–23). Ex. 8 UTC ≈ 9h hiver Paris.",
  "institution.reminders.fieldKind": "Type d’alerte",
  "institution.reminders.fieldDays": "Jours après l’événement",
  "institution.reminders.fieldHourUtc": "Heure de contrôle (UTC)",
  "institution.reminders.fieldEnabled": "Activer cette alerte",
  "institution.reminders.fieldLabel": "Libellé interne (optionnel)",
  "institution.reminders.fieldLabelPh": "ex. Relance J+3",
  "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
    "Formation : pas commencée X jours après inscription (création participant)",
  "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
    "Formation : non terminée X jours après la date limite du parcours (deadline)",
  "institution.reminders.ruleKind.path_incomplete_days_after_assign":
    "Parcours : non terminé X jours après assignation à l’apprenant",
  "institution.pages.brandingTitle": "Identité visuelle",
  "institution.pages.webhooksTitle": "Webhooks",
  "institution.pages.landingTitle": "Page publique",
  },
  en: {
    ...institutionBiStringsEn,
    ...institutionRegisterStringsEn,
    ...institutionRhCompetenciesStrings.en,
  "institution.flows.transferOwner": "Change trainer",
  "institution.flows.transferModalTitle": "Reassign course",
  "institution.flows.transferModalHint": "The new trainer becomes the owner (full rights). The previous owner loses owner and collaborator access to this course.",
  "institution.flows.transferPickUser": "New trainer",
  "institution.flows.transferSubmit": "Confirm transfer",
  "institution.flows.transferLoadingUsers": "Loading accounts…",
  "institution.flows.transferNoCandidates": "No other collaborator available",
  "institution.flows.transferError": "Transfer failed",
  "institution.flows.transferSuccess": "Trainer updated",
  "institution.tabs.home": "Home",
  "institution.tabs.rhDashboard": "HR overview",
  "institution.tabs.infpc": "INFPC (co-funding)",
  "institution.infpc.title": "INFPC co-funding request",
  "institution.infpc.subtitle":
    "Upload the official Excel template (e.g. demande-de-cofinancement-2026.xls) and JSON data: the tool reads course enrollments from LyrraStudio and fills Signalétique, Salariés + and category « Tab.* » sheets.",
  "institution.infpc.templateLabel": "Excel template (.xls or .xlsx)",
  "institution.infpc.templateHint": "Blank file from lifelong-learning.lu — do not change the layout.",
  "institution.infpc.companyJson": "company-config (JSON)",
  "institution.infpc.employeesJson": "employees (JSON array)",
  "institution.infpc.employeesHint":
    "Optional: one row per employee (lyrraEmail = learner e-mail). You can use [] and complete personal information on each learner profile, or paste a JSON array here.",
  "institution.infpc.trainingsJson": "trainings-config (JSON array)",
  "institution.infpc.allowMissing":
    "Exclude from the file learners enrolled on the course who have no matching employees entry (same email)",
  "institution.infpc.skipDraft": "Allow courses still in draft status",
  "institution.infpc.generate": "Generate pre-filled file (.xlsx)",
  "institution.infpc.generating": "Generating…",
  "institution.infpc.success": "Download started.",
  "institution.infpc.error": "Generation failed",
  "institution.infpc.docLink": "See technical spec (mapping, formulas, checks)",
  "institution.infpc.flowIdHint":
    "Each lyrraFlowId must be a UUID. Easiest: pick a course below and click Apply — or copy the id from the designer URL (…/flows/YOUR_UUID segment).",
  "institution.infpc.pickFlow": "Institution courses",
  "institution.infpc.pickFlowPlaceholder": "— Select a course —",
  "institution.infpc.applyFlowId": "Apply to first trainings-config entry",
  "institution.infpc.flowApplied": "Course UUID inserted into the JSON (first entry).",
  "institution.infpc.flowsLoading": "Loading courses…",
  "institution.infpc.flowsEmpty": "No courses found for this institution.",
  "institution.infpc.mustReplacePlaceholder":
    "Replace the example UUID with a real course (list above + Apply) or wait for courses to load.",
  "institution.infpc.flowPickerHint":
    "Prevents “course not found” errors: only courses owned by a user in your institution are accepted (same list as the Courses tab).",
  "institution.tabs.flows": "Courses",
  "institution.tabs.editorShares": "Publisher content",
  "institution.editorShares.view": "View",
  "institution.editorShares.use": "Use",
  "institution.editorShares.detail": "Details",
  "institution.editorShares.hideDetail": "Hide details",
  "institution.editorShares.assignTitle": "Assign to classes",
  "institution.editorShares.assignHint": "Learners in the selected classes will receive this content.",
  "institution.editorShares.assignSubmit": "Assign",
  "institution.editorShares.assignDone": "{{assigned}} new enrollment(s), {{already}} already enrolled.",
  "institution.editorShares.assignSkipped": "{{count}} learner(s) without an account were not enrolled.",
  "institution.editorShares.usedIn": "Already used in",
  "institution.editorShares.noClassYet": "Not assigned to a class yet.",
  "institution.editorShares.draftHint": "This course is not published: you can preview it, but not assign it yet.",
  "institution.editorShares.noClasses": "This establishment has no classes.",
  "institution.editorShares.episodes": "Episodes",
  "institution.editorShares.pathItems": "Path steps",
  "institution.editorShares.blocks": "{{count}} blocks",
  "institution.editorShares.episodeCount": "{{count}} episodes",
  "institution.editorShares.stepCount": "{{count}} steps",
  "institution.tabs.trash": "Trash",
  "institution.trash.subtitle": "Soft-deleted courses and podcasts — restore to make them visible again.",
  "institution.trash.loading": "Loading…",
  "institution.trash.empty": "Trash is empty.",
  "institution.trash.sectionFlows": "Courses",
  "institution.trash.sectionPodcasts": "Podcasts",
  "institution.trash.restore": "Restore",
  "institution.trash.owner": "Trainer",
  "institution.trash.restoredFlow": "Course restored.",
  "institution.trash.restoredPodcast": "Podcast restored.",
  "institution.trash.restoreError": "Could not restore.",
  "institution.trash.loadError": "Could not load trash.",
  "institution.trash.purgeButton": "Empty trash…",
  "institution.trash.purgeModalTitle": "Permanently empty trash",
  "institution.trash.purgeModalHint": "Items will be deleted with no way to restore them (courses, podcasts, and linked orphan episodes).",
  "institution.trash.purgeScopeLabel": "Scope",
  "institution.trash.purgeAllLabel": "Delete everything",
  "institution.trash.purgeAllDesc": "Permanently remove all items currently in the trash.",
  "institution.trash.purgeRangeLabel": "Date range",
  "institution.trash.purgeRangeDesc": "Only items moved to trash between these dates (by deletion date) will be permanently removed.",
  "institution.trash.purgeDateFrom": "From",
  "institution.trash.purgeDateTo": "To",
  "institution.trash.purgeConfirm": "Delete permanently",
  "institution.trash.purgeSuccess": "Trash emptied.",
  "institution.trash.purgeRangeMissingDates": "Please set both start and end dates.",
  "institution.trash.purgeRangeOrderError": "Start date must be before end date.",
  "institution.tabs.supports": "Podcasts",
  "institution.tabs.categories": "Categories",
  "institution.tabs.templates": "Block templates",
  "institution.tabs.contentPipeline": "Content prep",
  "institution.tabs.webinars": "Webinars",
  "institution.tabs.webinarsPilotage": "Webinar management",
  "institution.webinars.pageTitle": "Webinar settings",
  "institution.webinars.settingsIntro":
    "Enable the module and set the default waiting-room message. Webinar list and authorized hosts are managed in the « {{tabName}} » tab.",
  "institution.webinars.enableForInstitution": "Enable webinars for this institution",
  "institution.webinars.enabledBadge": "Module enabled",
  "institution.webinars.disabledBadge": "Module disabled",
  "institution.webinars.sectionModule": "Activation",
  "institution.webinars.sectionModuleHint":
    "Allows trainers in your institution to create and host live sessions.",
  "institution.webinars.sectionWaitingRoom": "Waiting room",
  "institution.webinars.waitingHtmlLabel": "Waiting room HTML (default)",
  "institution.webinars.waitingHtmlPlaceholder": "<p>Your welcome message…</p>",
  "institution.webinars.waitingHtmlHint":
    "Simple HTML shown to participants before the session starts. Colors follow this space’s theme.",
  "institution.webinars.openPilotage": "Open webinar management",
  "institution.webinars.waitingPreviewTitle": "Preview — waiting room message",
  "institution.webinars.waitingPreviewHint":
    "As participants see it before the webinar starts (colors follow this space’s theme).",
  "institution.webinars.loadError": "Could not load webinar settings.",
  "institution.webinars.saveSuccess": "Webinar settings saved.",
  "institution.webinars.saveError": "Could not save settings.",
  "institution.tabs.scorm": "SCORM import",
  "institution.tabs.designers": "Collaborators",
  "institution.tabs.learners": "Learners",
  "institution.tabs.learnerAnalytics": "Learner analytics",
  "institution.tabs.biStudio": "BI dashboards",
  "institution.tabs.classes": "Classes",
  "institution.tabs.evaluations": "Evaluations",
  "institution.evaluations.title": "Evaluations",
  "institution.evaluations.subtitle": "Class results on a course. Polls and self-assessment do not count.",
  "institution.evaluations.loadError": "Could not load evaluations.",
  "institution.evaluations.chooseClass": "Choose a class",
  "institution.evaluations.chooseFlow": "Choose a course",
  "institution.evaluations.emptyClass": "Choose a class to see its results.",
  "institution.evaluations.emptyFlow": "No course played by this class yet.",
  "institution.evaluations.emptyLearners": "This class has no learners yet.",
  "institution.evaluations.viewGrid": "Grid",
  "institution.evaluations.viewQueue": "Grading queue",
  "institution.evaluations.viewStats": "Questions",
  "institution.evaluations.viewSettings": "Rules",
  "institution.evaluations.viewCompetency": "Framework",
  "institution.evaluations.learner": "Learner",
  "institution.evaluations.total": "Total",
  "institution.evaluations.threshold": "Threshold",
  "institution.evaluations.queueEmpty": "Nothing to grade.",
  "institution.evaluations.proposal": "Proposal",
  "institution.evaluations.comment": "Comment for the learner",
  "institution.evaluations.validate": "Validate",
  "institution.evaluations.passPercent": "Pass threshold (%)",
  "institution.evaluations.attemptRule": "Attempt kept",
  "institution.evaluations.ruleLast": "Last attempt",
  "institution.evaluations.ruleBest": "Best attempt",
  "institution.evaluations.noSuggestion": "No level increase to suggest.",
  "institution.evaluations.applyLevel": "Apply the level increase",
  "institution.evaluations.learnerTitle": "My results",
  "institution.evaluations.attemptsLeft": "Attempts left",
  "institution.evaluations.attemptsReached": "No attempts left.",
  "institution.evaluations.openFromClass": "View evaluations",
  "institution.evaluations.status.passed": "Passed",
  "institution.evaluations.status.failed": "Not passed",
  "institution.evaluations.status.toReview": "Being graded",
  "institution.evaluations.status.inProgress": "In progress",
  "institution.evaluations.status.notStarted": "Not started",
  "institution.evaluations.status.counted": "Counted",
  "institution.evaluations.signal.easy": "Too easy",
  "institution.evaluations.signal.hard": "Too hard",
  "institution.evaluations.signal.balanced": "Balanced",
  "institution.evaluations.signal.insufficient": "Not enough answers",
  "institution.tabs.groups": "Groups",
  "institution.classes.title": "Classes",
  "offline.banner.offline": "Offline: your downloaded courses remain available.",
  "offline.banner.offlinePending": "Offline: {{count}} progress record(s) will be sent when the connection is back.",
  "offline.banner.syncing": "Syncing your progress… ({{count}} pending)",
  "offline.banner.synced": "Progress synced ({{count}}).",
  "offline.banner.failed": "{{count}} progress record(s) rejected by the server. Tell your teacher if your progress looks incomplete.",
  "offline.flow.download": "Make available offline",
  "offline.flow.progressContent": "Downloading content…",
  "offline.flow.progressMedia": "Media {{done}} / {{total}}…",
  "offline.flow.progressApp": "Preparing the offline app…",
  "offline.flow.ready": "Available offline",
  "offline.flow.partial": "{{count}} external or unavailable media: online playback only.",
  "offline.flow.update": "Update",
  "offline.flow.remove": "Remove",
  "offline.flow.notAvailable": "Not downloaded: connection required",
  "offline.flow.unsupported": "This browser does not support offline mode.",
  "offline.flow.error": "Download interrupted. Try again with a connection.",
  "institution.classes.importCsv": "Import (CSV)",
  "institution.classes.importTitle": "Import students into the class",
  "institution.classes.importHelp": "CSV file with three columns: first name, last name, email (separator \";\" or \",\"). {{max}} rows maximum. Missing accounts are created as student accounts.",
  "institution.classes.importTemplate": "Download the template",
  "institution.classes.importFile": "CSV file",
  "institution.classes.importPreview": "{{count}} student(s) read from {{file}}.",
  "institution.classes.importSkipped": "Rows skipped (no email): {{lines}}",
  "institution.classes.importInvite": "Send each new account an email to choose a password",
  "institution.classes.importRun": "Import",
  "institution.classes.importResult": "{{added}} student(s) added to the class, {{created}} account(s) created, {{already}} already in the class, {{invited}} invitation(s) being sent.",
  "institution.classes.importErrors": "{{count}} row(s) not imported:",
  "institution.classes.importErrorLine": "Row {{line}} ({{email}}): {{reason}}",
  "institution.classes.importEmpty": "No students found in this file.",
  "institution.classes.importTooMany": "The file has more than {{max}} rows: split it.",
  "institution.classes.importReadError": "The file could not be read.",
  "institution.classes.close": "Close",
  "institution.classes.notifyStudents": "Notify newly enrolled students by email",
  "institution.classes.flowsTitle": "Class courses",
  "institution.classes.flowsHint": "Assign a published course to the whole class. Students already enrolled are not duplicated.",
  "institution.classes.chooseFlow": "Choose a published course",
  "institution.classes.assignFlow": "Assign to the class",
  "institution.classes.assignDone": "{{assigned}} student(s) enrolled, {{already}} already enrolled.",
  "institution.classes.noFlows": "No published course available for this establishment.",
  "institution.classes.enrolledCount": "{{enrolled}} / {{total}} enrolled",
  "institution.classes.subtitle": "A class has one lead, trainers and students. Import the student list and assign courses to everyone at once.",
  "institution.classes.create": "Create a class",
  "institution.classes.loadError": "Could not load classes.",
  "institution.classes.saveError": "Could not save.",
  "institution.classes.search": "Search a class…",
  "institution.classes.empty": "No class yet. Create the first one from this screen.",
  "institution.classes.emptyFilter": "No class matches the search.",
  "institution.classes.colName": "Class",
  "institution.classes.lead": "Class lead",
  "institution.classes.leadPlaceholder": "Choose a class lead",
  "institution.classes.leadHint": "The lead follows the class (head teacher, coordinator or management). Trainers teach their subjects in it.",
  "institution.classes.leadMissing": "No lead",
  "institution.classes.noLead": "Create a trainer, training-lead or administrator account in Collaborators first.",
  "institution.classes.trainers": "Trainers",
  "institution.classes.learners": "Learners",
  "institution.classes.addTrainer": "Add a trainer",
  "institution.classes.addLearner": "Add a learner",
  "institution.classes.noTrainers": "No trainer in this class.",
  "institution.classes.noLearners": "No learner in this class.",
  "institution.classes.noTrainerAvailable": "No trainer available.",
  "institution.classes.noLearnerAvailable": "No learner available.",
  "institution.classes.searchPeople": "Search…",
  "institution.classes.back": "Back to classes",
  "institution.classes.remove": "Remove",
  "institution.classes.modalCreate": "Create a class",
  "institution.classes.modalEdit": "Edit the class",
  "institution.classes.fieldName": "Class name",
  "institution.classes.confirmDeleteTitle": "Delete this class?",
  "institution.classes.confirmDeleteBody": "The class “{{name}}” will be deleted. Accounts are kept.",
  "institution.classes.confirmRemoveTitle": "Remove this person?",
  "institution.classes.confirmRemoveBody": "{{name}} will be removed from the class. The account is kept.",
  "institution.tabs.services": "Services",
  "institution.tabs.sirh": "HRIS (API)",
  "institution.tabs.branding": "Branding",
  "institution.tabs.landing": "Public page",
  "institution.tabs.webhooks": "Webhooks",
  "institution.tabs.xapi": "xAPI (LRS)",
  "institution.tabs.mcp": "MCP",
  "institution.tabs.billing": "Billing",
  "institution.nav.section.general": "Overview",
  "institution.nav.section.content": "Content & training",
  "institution.nav.section.people": "Teams & learners",
  "institution.nav.section.portal": "Portal & branding",
  "institution.nav.section.integrations": "Integrations",
  "institution.nav.section.subscription": "Subscription",
  "institution.nav.section.rhTools": "Training & HR",
  "institution.rhNav.campaigns": "Campaigns",
  "institution.rhNav.codir": "Executive (CODIR) dashboard",
  "institution.rhNav.catalog": "Catalog",
  "institution.rhNav.competencies": "Competencies",
  "institution.rhNav.compliance": "Compliance",
  "institution.rhNav.requests": "Requests & workflows",
  "institution.sidebar.subtitle": "Institution",
  "institution.sidebar.subtitleRh": "HR space",
  "institution.sidebar.subtitleAdmin": "Administration",
  "institution.sidebar.subtitleEducation": "School",
  "institution.designers.colClasses": "Classes",
  "institution.sidebar.logout": "Log out",
  "institution.sidebar.collapse": "Collapse menu",
  "institution.sidebar.expandAria": "Expand sidebar",
  "institution.sidebar.collapseAria": "Collapse sidebar",
  "institution.sidebar.language": "Language",
  "institution.sidebar.languageAria": "Change language",
  "institution.header.workspace": "Institution workspace",
  "institution.common.cancel": "Cancel",
  "institution.common.save": "Save",
  "institution.common.saving": "Saving…",
  "institution.common.delete": "Delete",
  "institution.common.edit": "Edit",
  "institution.common.create": "Create",
  "institution.common.add": "Add",
  "institution.common.retry": "Retry",
  "institution.common.refresh": "Refresh",
  "institution.common.search": "Search…",
  "institution.common.loading": "Loading…",
  "institution.common.page": "Page",
  "institution.common.of": "of",
  "institution.common.name": "Name",
  "institution.common.description": "Description",
  "institution.common.email": "Email",
  "institution.common.member": "Member",
  "institution.common.members": "Members",
  "institution.common.back": "Back",
  "institution.common.view": "View",
  "institution.common.duplicate": "Duplicate",
  "institution.common.toggleStatus": "Enable / disable",
  "institution.common.author": "Author",
  "institution.common.title": "Title",
  "institution.common.status": "Status",
  "institution.common.type": "Type",
  "institution.common.actions": "Actions",
  "institution.common.createdAt": "Created",
  "institution.common.assignedTo": "Assigned to",
  "institution.common.completion": "Completion",
  "institution.common.learners": "Learners",
  "institution.common.empty": "—",
  "institution.status.draft": "Draft",
  "institution.status.published": "Published",
  "institution.status.archived": "Archived",
  "institution.status.allStatuses": "All statuses",
  "institution.status.allTypes": "All types",
  "institution.dashboard.loading": "Loading dashboard…",
  "institution.dashboard.loadError": "Unable to load the dashboard.",
  "institution.dashboard.activity.completion": "Completion",
  "institution.dashboard.activity.enrollment": "Enrollment",
  "institution.dashboard.activity.milestone": "Milestone",
  "institution.dashboard.activity.feedback": "Feedback",
  "institution.dashboard.activity.start": "Start",
  "institution.dashboard.activity.1": "Marie Dupont completed “UX Fundamentals”",
  "institution.dashboard.activity.2": "12 new learners enrolled in “Design Thinking”",
  "institution.dashboard.activity.3": "Group “Cohort Q3” reached 80% completion",
  "institution.dashboard.activity.4": "NPS survey received 24 new responses",
  "institution.dashboard.activity.5": "Jean Martin started “Agile methods”",
  "institution.dashboard.time.5m": "5 min ago",
  "institution.dashboard.time.1h": "1h ago",
  "institution.dashboard.time.3h": "3h ago",
  "institution.dashboard.time.5h": "5h ago",
  "institution.dashboard.time.6h": "6h ago",
  "institution.dashboard.activity.flowCompleted": "{{name}} completed “{{flow}}”",
  "institution.dashboard.activity.participantJoined": "Learner added: {{email}}",
  "institution.dashboard.activity.flowStarted": "{{name}} started “{{flow}}”",
  "institution.dashboard.chartTopFlowsEmpty": "Not enough data yet. Publish courses and invite learners.",
  "institution.dashboard.activityEmpty": "No recent activity.",
  "institution.dashboard.home.greeting": "Hello, {{name}}",
  "institution.dashboard.home.greetingSubtitle": "Your institution at a glance — courses, learners, and recent activity.",
  "institution.dashboard.home.defaultName": "team",
  "institution.dashboard.home.primaryCta": "Manage courses",
  "institution.dashboard.home.secondaryCta": "View learners",
  "institution.dashboard.home.completionRate": "Completion rate",
  "institution.dashboard.home.quickAccess": "Quick access",
  "institution.dashboard.home.viewAllActivity": "All activity",
  "institution.dashboard.home.calendarKicker": "Activity this month",
  "institution.dashboard.home.alertNotStarted": "{{count}} enrollment(s) not started",
  "institution.dashboard.home.alertStalled": "{{count}} stalled progress",
  "institution.dashboard.home.topFlows": "Top courses",
  "institution.dashboard.home.topFlowsHint": "Completion rate per course for the selected period.",
  "institution.dashboard.home.periodLabel": "Period",
  "institution.groups.title": "Group management",
  "institution.groups.countShown": "{{count}} group(s)",
  "institution.groups.subtitle": "{{count}} group(s) in your institution",
  "institution.groups.create": "Create group",
  "institution.groups.statGroups": "Groups",
  "institution.groups.statTotalMembers": "Total members",
  "institution.groups.statEmpty": "Empty groups",
  "institution.groups.loadError": "Unable to load groups.",
  "institution.groups.searchPh": "Search a group…",
  "institution.groups.colGroup": "Group",
  "institution.groups.colCreated": "Created",
  "institution.groups.memberCount": "{{count}} member(s)",
  "institution.groups.emptyNone": "No groups yet. Create your first group.",
  "institution.groups.emptyFilter": "No groups match your search.",
  "institution.groups.backList": "Back to groups",
  "institution.groups.addLearner": "Add learner",
  "institution.groups.dateCreated": "Created on",
  "institution.groups.colMember": "Member",
  "institution.groups.colAdded": "Added on",
  "institution.groups.noMembers": "No members in this group",
  "institution.groups.loadGroupError": "Unable to load the group",
  "institution.groups.panelTitle": "Add learners",
  "institution.groups.noLearnersAvailable": "No learners available",
  "institution.groups.noResults": "No results",
  "institution.groups.modalEdit": "Edit group",
  "institution.groups.modalCreate": "Create group",
  "institution.groups.groupName": "Group name",
  "institution.groups.removeFromGroup": "Remove from group",
  "institution.groups.confirmDeleteTitle": "Delete this group?",
  "institution.groups.confirmDeleteBody": "The group “{{name}}” will be deleted. Learners stay in the institution, without this assignment.",
  "institution.groups.confirmRemoveTitle": "Remove this member?",
  "institution.groups.confirmRemoveBody": "{{name}} will be removed from “{{group}}”. Their account is not deleted.",
  "institution.groups.confirmRemoveAction": "Remove from group",
  "institution.groups.noTeacher": "No teacher",
  "institution.groups.teacherLabel": "Teacher in charge",
  "institution.groups.teacherHint": "The teacher finds this group in their workspace and can add or remove students.",
  "institution.groups.teacherIs": "Teacher: {{name}}",
  "institution.groups.teacherTitle": "My support groups",
  "institution.groups.teacherHint2": "Groups assigned to you and groups you created. You can add students from your classes or remove students, and delete the groups you created.",
  "institution.groups.colTeacher": "Teacher",
  "institution.groups.saveError": "Could not save.",
  "institution.groups.teacherLearnersHint": "Only students from your classes are listed.",
  "institution.services.title": "Company services",
  "institution.services.subtitle":
    "Directory of business units (HR, Finance, etc.). Learners are assigned from the learner profile.",
  "institution.services.create": "New service",
  "institution.services.loadError": "Unable to load services.",
  "institution.services.empty": "No services yet. Create one to assign learners.",
  "institution.services.modalCreate": "Create service",
  "institution.services.modalEdit": "Edit service",
  "institution.services.fieldName": "Service name",
  "institution.services.deleteConfirm": "Delete this service? Learners linked to it will no longer have a service assigned.",
  "institution.services.listSubtitle": "{{count}} service(s) in your institution",
  "institution.services.intro":
    "Directory of business units (HR, Finance, etc.). Learners are assigned from the learner profile.",
  "institution.services.statTotal": "Services",
  "institution.services.statWithDesc": "With description",
  "institution.services.statNoDesc": "Without description",
  "institution.services.searchPh": "Search a service…",
  "institution.services.colService": "Service",
  "institution.services.colCreated": "Created",
  "institution.services.emptyNone": "No services yet. Create your first service.",
  "institution.services.emptyFilter": "No services match your search.",
  "institution.services.countShown": "{{count}} service(s)",
  "institution.flows.title": "Courses",
  "institution.flows.subtitle": "Manage your courses",
  "institution.flows.statTotal": "Total courses",
  "institution.flows.statPublished": "Published",
  "institution.flows.statLearners": "Total learners",
  "institution.flows.searchPh": "Search a course…",
  "institution.flows.colName": "Name",
  "institution.flows.empty": "No course found",
  "institution.flows.badgeEnterprise": "Enterprise training need",
  "institution.flows.deleteEnterpriseTooltip": "Move to trash (enterprise need)",
  "institution.flows.deleteEnterpriseTitle": "Remove this enterprise-linked course?",
  "institution.flows.deleteEnterpriseHint": "The course will be soft-deleted. Trainers cannot do this; only institution admin, DRH or HR can restore or remove it from this dashboard.",
  "institution.flows.deleteEnterpriseConfirm": "Move to trash",
  "institution.flows.deleteEnterpriseSuccess": "Course moved to trash.",
  "institution.flows.deleteEnterpriseError": "Action failed.",
  "institution.learningPaths.sectionTitle": "Learning paths",
  "institution.learningPaths.sectionSubtitle": "Paths owned by a member of your institution.",
  "institution.learningPaths.searchPh": "Search a path…",
  "institution.learningPaths.colItems": "Items",
  "institution.learningPaths.colAssignments": "Assignments",
  "institution.learningPaths.transferOwner": "Reassign owner",
  "institution.learningPaths.transferModalTitle": "Change path owner",
  "institution.learningPaths.transferModalHint":
    "The selected account becomes the owner; referenced library media (e.g. cover) moves when traceable in the database.",
  "institution.learningPaths.transferPickUser": "New owner",
  "institution.learningPaths.transferSubmit": "Confirm transfer",
  "institution.learningPaths.transferLoadingUsers": "Loading accounts…",
  "institution.learningPaths.transferNoCandidates": "No other collaborator available",
  "institution.learningPaths.transferError": "Transfer failed",
  "institution.learningPaths.transferSuccess": "Owner updated",
  "institution.learningPaths.empty": "No path found",
  "institution.supports.title": "Podcasts",
  "institution.supports.subtitle": "Podcasts and audio content",
  "institution.supports.searchPh": "Search a podcast…",
  "institution.supports.empty": "No podcast found",
  "institution.supports.typeDictation": "Dictation",
  "institution.supports.typeText": "Text",
  "institution.supports.typeAi": "AI",
  "institution.supports.typePodcast": "Podcast",
  "institution.supports.allProductionStatuses": "All statuses",
  "institution.supports.colKind": "Type",
  "institution.supports.colEpisodes": "Episodes",
  "institution.supports.colProducer": "Producer",
  "institution.supports.colCreator": "Created by",
  "institution.supports.loadError": "Could not load podcasts.",
  "institution.supports.transferOwner": "Reassign podcast creator",
  "institution.supports.transferModalTitle": "Change podcast owner",
  "institution.supports.transferModalHint":
    "The selected account becomes the podcast creator; episodes and referenced library media move when traceable in the database.",
  "institution.supports.transferPickUser": "New creator",
  "institution.supports.transferSubmit": "Confirm transfer",
  "institution.supports.transferLoadingUsers": "Loading accounts…",
  "institution.supports.transferNoCandidates": "No other collaborator available",
  "institution.supports.transferError": "Transfer failed",
  "institution.supports.transferSuccess": "Creator updated",
  "institution.supports.previewError": "Could not open podcast preview.",
  "institution.podcastProduction.shell": "Shell",
  "institution.podcastProduction.assigned": "Assigned",
  "institution.podcastProduction.in_production": "In production",
  "institution.podcastProduction.ready": "Ready",
  "institution.categories.title": "Categories",
  "institution.categories.subtitle": "Organize your courses by topic",
  "institution.categories.add": "Add",
  "institution.categories.edit": "Edit category",
  "institution.categories.new": "New category",
  "institution.categories.usage": "{{count}} course(s)",
  "institution.categories.pageSubtitle": "Organize your content by category",
  "institution.categories.namePlaceholder": "Category name",
  "institution.categories.color": "Color",
  "institution.categories.descShortPh": "Short description",
  "institution.categories.usageTimes": "({{count}} uses)",
  "institution.templates.title": "Block templates",
  "institution.templates.subtitle": "Reusable template library",
  "institution.templates.statTotal": "Templates",
  "institution.templates.statUsage": "Total uses",
  "institution.templates.mostUsed": "Most used type",
  "institution.templates.preview": "Preview",
  "institution.templates.searchPh": "Search a template…",
  "institution.templates.copySuffix": " (copy)",
  "institution.templates.empty": "No templates found",
  "institution.templates.loadFormatError": "Could not load templates (invalid server response).",
  "institution.templates.usesShort": "{{count}} uses",
  "institution.templates.filterAll": "All types",
  "institution.blockTypes.text": "Text",
  "institution.blockTypes.quiz": "Quiz",
  "institution.blockTypes.video": "Video",
  "institution.blockTypes.audio": "Audio",
  "institution.blockTypes.image": "Image",
  "institution.blockTypes.document": "Document",
  "institution.blockTypes.code": "Code",
  "institution.blockTypes.discussion": "Discussion",
  "institution.scorm.title": "SCORM import",
  "institution.scorm.subtitle": "Import SCORM 1.2 or 2004 packages",
  "institution.scorm.dropHere": "Drag and drop your SCORM (.zip) file here",
  "institution.scorm.browseHint": "or click to browse",
  "institution.scorm.selectedFile": "Selected file: {{name}}",
  "institution.scorm.startImport": "Start import",
  "institution.scorm.importingNamed": "Import in progress: {{name}}",
  "institution.scorm.analyzing": "Analyzing modules… {{pct}}%",
  "institution.scorm.historyTitle": "Import history",
  "institution.scorm.colFile": "File",
  "institution.scorm.colDate": "Date",
  "institution.scorm.colStatus": "Status",
  "institution.scorm.colModules": "Modules",
  "institution.scorm.colVersion": "Version",
  "institution.scorm.colFlow": "Course",
  "institution.scorm.empty": "No imports yet. Drop a SCORM .zip file above.",
  "institution.scorm.openFlow": "Open",
  "institution.scorm.statusImporting": "Importing…",
  "institution.scorm.statusSuccess": "Success",
  "institution.scorm.statusError": "Error",
  "institution.designers.title": "Collaborators",
  "institution.designers.subtitle": "Institution accounts, grouped by role: trainers, training leads, HR and managers.",
  "institution.designers.invite": "Invite",
  "institution.designers.statTotal": "Total collaborators",
  "institution.designers.statActiveMonth": "Active this month",
  "institution.designers.statFlows": "Courses created (total)",
  "institution.designers.inviteTitle": "Invite a collaborator",
  "institution.designers.inviteHelp": "Choose a role: Trainer (content / courses), HR lead, HR staff, or Admin (institution administrator on Lyrra).",
  "institution.designers.emailPh": "email@example.com",
  "institution.designers.sendInvite": "Send invitation",
  "institution.designers.loadError": "Unable to load collaborators",
  "institution.designers.inviteFail": "Invitation failed",
  "institution.designers.actionFail": "Action failed",
  "institution.designers.searchPh": "Search by name or email…",
  "institution.designers.colName": "Name",
  "institution.designers.colEmail": "Email",
  "institution.designers.colRole": "Role",
  "institution.designers.colProjects": "Projects",
  "institution.designers.colLastActivity": "Last activity",
  "institution.designers.colStatus": "Status",
  "institution.designers.colActions": "Actions",
  "institution.designers.empty": "No collaborator found",
  "institution.designers.roleAdmin": "Admin",
  "institution.designers.roleTeacher": "Trainer",
  "institution.designers.roleTrainingLead": "Training lead",
  "institution.designers.roleCollaborator": "Collaborator",
  "institution.designers.roleOptFormateur": "Trainer",
  "institution.designers.roleOptDrh": "HR lead",
  "institution.designers.roleOptRh": "HR",
  "institution.designers.roleOptAdmin": "Admin",
  "institution.designers.statusActive": "Active",
  "institution.designers.statusInvited": "Invited",
  "institution.designers.statusSuspended": "Suspended",
  "institution.designers.menuView": "View profile",
  "institution.designers.menuMakeAdmin": "Make admin",
  "institution.designers.menuSuspend": "Suspend",
  "institution.designers.menuRemove": "Remove",
  "institution.designers.noLinkedLearner": "No learner profile is linked to this email.",
  "institution.designers.createLinkedLearner": "Create learner profile",
  "institution.designers.creatingLinkedLearner": "Creating…",
  "institution.designers.createLinkedLearnerFail": "Could not create the learner profile",
  "institution.mcp.title": "MCP — Model Context Protocol",
  "institution.landing.designerTitle": "Page designer",
  "institution.learners.title": "Learners",
  "institution.learners.searchPh": "Search a learner…",
  "institution.learners.filterStatus": "Status",
  "institution.learners.filterPlaceholder": "Filter",
  "institution.learners.selectedCount": "{{count}} selected",
  "institution.learners.exportSelection": "Export selection",
  "institution.learners.exportAll": "Export all",
  "institution.learners.colLearner": "Learner",
  "institution.learners.colGroup": "Group",
  "institution.learners.colLastActive": "Last activity",
  "institution.learners.colStatus": "Status",
  "institution.learners.empty": "No learner found",
  "institution.learners.countList": "{{count}} learner(s)",
  "institution.learners.subtitle": "{{count}} learner(s) enrolled in your institution",
  "institution.learners.importCsv": "Import CSV",
  "institution.learners.add": "Add",
  "institution.learners.addModalTitle": "New learner",
  "institution.learners.addModalHint":
    "Creates the record for your institution. If the email has no LyrraStudio account yet, an email is sent to set the password.",
  "institution.learners.addEmail": "Email",
  "institution.learners.addSendInvitation": "Send invitation email (new accounts only)",
  "institution.learners.addSubmit": "Create",
  "institution.learners.addError": "Could not create the learner",
  "institution.learners.statLearners": "Learners",
  "institution.learners.statActive30": "Active (30d)",
  "institution.learners.statEnrollments": "Enrollments",
  "institution.learners.statCompleted": "Completed courses",
  "institution.learners.statusAll": "All statuses",
  "institution.learners.statusActive": "Active",
  "institution.learners.statusInactive": "Inactive",
  "institution.learners.statusCompleted": "Completed",
  "institution.learners.sheetTitle": "Learner profile",
  "institution.learners.openProfileDetail": "Profile details",
  "institution.learners.groupsCatalogTitle": "Configured groups",
  "institution.learners.groupsCatalogSubtitle": "Defined in your institution’s « Groups » tab.",
  "institution.learners.replacePhoto": "Replace",
  "institution.learners.addPhoto": "Add photo",
  "institution.learners.removePhoto": "Remove",
  "institution.learners.firstName": "First name",
  "institution.learners.lastName": "Last name",
  "institution.learners.save": "Save",
  "institution.learners.deactivate": "Deactivate",
  "institution.learners.reactivate": "Reactivate",
  "institution.learners.lastActivity": "Last activity:",
  "institution.learners.paths": "Paths ({{count}})",
  "institution.learners.noPaths": "No assigned path",
  "institution.learners.noFlowsEnrolled": "No enrolled course",
  "institution.learners.done": "Done",
  "institution.learners.inProgress": "In progress",
  "institution.learners.itemsProgress": "{{done}}/{{total}} items",
  "institution.learners.flows": "Courses",
  "institution.learners.completedF": "Completed",
  "institution.learners.totalTime": "Total time",
  "institution.learners.progress": "Progress",
  "institution.learners.flowDone": "Completed",
  "institution.learners.blocks": "{{visited}}/{{total}} blocks",
  "institution.learners.score": "Score: {{score}}%",
  "institution.learners.sessions": "{{count}} sessions",
  "institution.learners.started": "Started:",
  "institution.learners.ended": "Ended:",
  "institution.learners.lastAccess": "Last access:",
  "institution.learners.podcasts": "Podcasts",
  "institution.learners.noPodcastListen": "No listening recorded",
  "institution.learners.deleteTitle": "Delete this learner?",
  "institution.learners.deleteDesc": "Are you sure you want to permanently delete {{name}} ({{email}})? This cannot be undone and will remove all related data.",
  "institution.learners.deactivateTitle": "Deactivate this learner?",
  "institution.learners.reactivateTitle": "Reactivate this learner?",
  "institution.learners.deactivateDesc": "{{name}} will not be able to access courses while deactivated.",
  "institution.learners.reactivateDesc": "{{name}} will regain access to their courses.",
  "institution.learners.deleteLearner": "Delete this learner",
  "institution.learners.photoUploadError": "Error uploading photo",
  "institution.learners.photoRemoveError": "Error removing photo",
  "institution.learners.service": "Service",
  "institution.learners.serviceHint": "Pick an entry from the directory (Services tab). Type to filter the list.",
  "institution.learners.serviceSearch": "Search a service…",
  "institution.learners.serviceNone": "No service",
  "institution.learners.infpc.sectionTitle": "Personal information",
  "institution.learners.infpc.sectionHint":
    "Additional details useful for administrative procedures and training-related declarations (optional fields depending on context).",
  "institution.learners.infpc.gender": "Gender",
  "institution.learners.infpc.genderPlaceholder": "—",
  "institution.learners.infpc.genderM": "Male",
  "institution.learners.infpc.genderF": "Female",
  "institution.learners.infpc.csp": "Occupational category",
  "institution.learners.infpc.cspPlaceholder": "— Select —",
  "institution.learners.infpc.csp.manual_worker": "Manual worker",
  "institution.learners.infpc.csp.employee": "Employee",
  "institution.learners.infpc.csp.technician": "Technician",
  "institution.learners.infpc.csp.supervisor": "Supervisor",
  "institution.learners.infpc.csp.executive": "Executive",
  "institution.learners.infpc.csp.director": "Director",
  "institution.learners.infpc.hasDiploma": "Diploma (required level)",
  "institution.learners.infpc.seniority": "Seniority (years)",
  "institution.learners.infpc.age": "Age",
  "institution.learners.infpc.salariePlus": "Salarié +",
  "institution.learners.infpc.salariePlusType": "Salarié + type",
  "institution.learners.infpc.salariePlusTypePlaceholder": "—",
  "institution.learners.infpc.salariePlusType1": "Type 1 (young / no diploma required)",
  "institution.learners.infpc.salariePlusType2": "Type 2",
  "institution.learners.infpc.hireDate": "Hire date (DD/MM/YYYY)",
  "institution.learners.infpc.birthDate": "Birth date (DD/MM/YYYY)",
  "institution.learners.infpc.save": "Save information",
  "institution.learners.infpc.saved": "Information saved.",
  "institution.learners.exportSheetLearners": "Learners",
  "institution.learners.exportSheetDetails": "Course details",
  "institution.learners.export.firstName": "First name",
  "institution.learners.export.lastName": "Last name",
  "institution.learners.export.groupCol": "Group",
  "institution.learners.export.enrollments": "Enrolled courses",
  "institution.learners.export.completed": "Completed courses",
  "institution.learners.export.progressPct": "Progress (%)",
  "institution.learners.export.totalMin": "Total time (min)",
  "institution.learners.export.lastAct": "Last activity",
  "institution.learners.export.statusCol": "Status",
  "institution.learners.export.learnerCol": "Learner",
  "institution.learners.export.typeCol": "Type",
  "institution.learners.export.titleCol": "Title",
  "institution.learners.export.blocks": "Blocks visited / Total",
  "institution.learners.export.sessionsDone": "Sessions completed",
  "institution.learners.export.avgScore": "Average score (%)",
  "institution.learners.export.timeMin": "Time spent (min)",
  "institution.learners.export.dateStart": "Start date",
  "institution.learners.export.dateEnd": "End date",
  "institution.learners.export.lastAcc": "Last access",
  "institution.learners.export.typeCourse": "Course",
  "institution.learners.export.typePath": "Path",
  "institution.reminders.openPanel": "Email reminders",
  "institution.reminders.panelTitle": "Reminders",
  "institution.reminders.panelSubtitle":
    "Automatic alerts emailed to concerned learners. A server job runs every hour at the chosen UTC hour. Each rule sends at most once per learner.",
  "institution.reminders.sectionRules": "Rules",
  "institution.reminders.sectionLogs": "Send log",
  "institution.reminders.addRule": "Add alert",
  "institution.reminders.removeRule": "Remove this alert",
  "institution.reminders.save": "Save rules",
  "institution.reminders.loadError": "Could not load reminders.",
  "institution.reminders.saveError": "Could not save.",
  "institution.reminders.rulesEmpty": "No alerts yet. Add a rule, or save an empty list to clear all reminders for this item.",
  "institution.reminders.logsEmpty": "No sends recorded yet.",
  "institution.reminders.utcHint": "Pick the UTC hour (0–23) when the server evaluates this rule.",
  "institution.reminders.fieldKind": "Alert type",
  "institution.reminders.fieldDays": "Days after the anchor event",
  "institution.reminders.fieldHourUtc": "Check hour (UTC)",
  "institution.reminders.fieldEnabled": "Enable this alert",
  "institution.reminders.fieldLabel": "Internal label (optional)",
  "institution.reminders.fieldLabelPh": "e.g. Nudge D+3",
  "institution.reminders.ruleKind.eduflow_not_started_days_after_enroll":
    "Course: not started X days after enrollment (participant record)",
  "institution.reminders.ruleKind.eduflow_incomplete_days_after_deadline":
    "Course: still incomplete X days after the flow deadline",
  "institution.reminders.ruleKind.path_incomplete_days_after_assign":
    "Path: incomplete X days after assignment to the learner",
  "institution.pages.brandingTitle": "Visual identity",
  "institution.pages.webhooksTitle": "Webhooks",
  "institution.pages.landingTitle": "Public page",
  },
};